export const uploadForm = {
  ownerId: {},
  directoryId: {}
};